import { useFormikContext } from 'formik'
import React from 'react'

import { translationsContext } from 'context/translations'
import { Calculate } from 'types/graphql/schema'
import { valuesType } from 'utils/values'

import { TableSection } from '../components/TableSection'
import { FieldSoB } from '../components/FieldSoB'
import { formatValue as f, formatUnits as fu } from '../utils'


export function SectionLongTermReturnsHealth(props: {
  calculate: (values: valuesType) => void
  calculationResult: Calculate
  isPdf: boolean
}) {
  const t = React.useContext(translationsContext)
  const v = props.calculationResult
  const {values} = useFormikContext<valuesType>()
  return <TableSection
    colorGroupText="white"
    colorGroupBg="#C1CC00"
    colorTableBg="#F3F5CC"
    colorResultBg="#C1CC00"
    columns={[
      [
        '',
        '',
        {content: t('calc__health__column_1_3'), cellProps: {colSpan: 2, sx: {textAlign: 'center', pt: '16px !important'}}},
        {content: t('calc__health__column_1_4'), cellProps: {sx: {textAlign: 'center', pt: '16px !important'}}},
        {content: `${t('calc__health__column_1_5')} (${v.currency.sign}/${t('units__herd')}-${t('units__cow')}/${t('units__year')})`, cellProps: {colSpan: 3, sx: {textAlign: 'center', pt: '16px !important'}}}
      ],
      [
        '',
        {content: <><b>{t('calc__health__column_2_2_1')}</b> ({t('calc__health__column_2_2_2')})</>},
        {
          content: t('calc__health__column_2_3'),
          tooltip: t('calc__health__column_2_3__tt'),
        },
        {
          content: t('calc__health__column_2_4'),
          tooltip: t('calc__health__column_2_4__tt'),
        },
        {
          content: `${v.currency.sign}/${t('units__case')}`,
          tooltip: t('calc__health__column_2_5__tt'),
        },
        t('values__current'),
        t('values__reduced'),
        t('values__difference'),
      ]
    ]}
    data={[
      [
        t('calc__health__1_1'),
        fu(t('calc__health__1_2')),
        {content: <FieldSoB calculate={props.calculate}  isPdf={props.isPdf} name="longTermReturnsMastitisRegular" />},
        {content: <FieldSoB calculate={props.calculate}  isPdf={props.isPdf} name="longTermReturnsMastitisReduced" />},
        {content: <FieldSoB calculate={props.calculate}  isPdf={props.isPdf} name="longTermReturnsMastitisCostPerCase" />},
        f(v.longTermReturnsHealth.mastitis.current, 0),
        f(v.longTermReturnsHealth.mastitis.withProduct, 0),
        f(v.longTermReturnsHealth.mastitis.difference, 0),
      ],
      [
        t('calc__health__2_1'),
        fu(t('calc__health__2_2')),
        {content: <FieldSoB calculate={props.calculate}  isPdf={props.isPdf} name="longTermReturnsKetosisClinicalRegular" />},
        {content: <FieldSoB calculate={props.calculate}  isPdf={props.isPdf} name="longTermReturnsKetosisClinicalReduced" />},
        {content: <FieldSoB calculate={props.calculate}  isPdf={props.isPdf} name="longTermReturnsKetosisClinicalCostPerCase" />},
        f(v.longTermReturnsHealth.ketosisClinical.current, 0),
        f(v.longTermReturnsHealth.ketosisClinical.withProduct, 0),
        f(v.longTermReturnsHealth.ketosisClinical.difference, 0),
      ],
      [
        t('calc__health__3_1'),
        fu(t('calc__health__3_2')),
        {content: <FieldSoB calculate={props.calculate}  isPdf={props.isPdf} name="longTermReturnsKetosisSubClinicalRegular" />},
        {content: <FieldSoB calculate={props.calculate}  isPdf={props.isPdf} name="longTermReturnsKetosisSubClinicalReduced" />},
        {content: <FieldSoB calculate={props.calculate}  isPdf={props.isPdf} name="longTermReturnsKetosisSubclinicalCostPerCase" />},
        f(v.longTermReturnsHealth.ketosisSubclinical.current, 0),
        f(v.longTermReturnsHealth.ketosisSubclinical.withProduct, 0),
        f(v.longTermReturnsHealth.ketosisSubclinical.difference, 0),
      ],
      [
        t('calc__health__4_1'),
        fu(t('calc__health__4_2')),
        {content: <FieldSoB calculate={props.calculate}  isPdf={props.isPdf} name="longTermReturnsMetritisRegular" />},
        {content: <FieldSoB calculate={props.calculate}  isPdf={props.isPdf} name="longTermReturnsMetritisReduced" />},
        {content: <FieldSoB calculate={props.calculate}  isPdf={props.isPdf} name="longTermReturnsMetritisCostPerCase" />},
        f(v.longTermReturnsHealth.metritis.current, 0),
        f(v.longTermReturnsHealth.metritis.withProduct, 0),
        f(v.longTermReturnsHealth.metritis.difference, 0),
      ],
      [
        {content: t('calc__health__5_1'), borderTop: true},
        {...fu(`${v.currency.sign}/${t('units__cow')}/${t('units__year')}`), borderTop: true},
        {...f(''), borderTop: true},
        {...f(''), borderTop: true},
        {...f(''), borderTop: true},
        {...f(v.longTermReturnsHealth.totalSavings.current, 0), borderTop: true},
        {...f(v.longTermReturnsHealth.totalSavings.withProduct, 0), borderTop: true},
        {...f(v.longTermReturnsHealth.totalSavings.difference, 2), borderTop: true},
      ],
    ]}
    dataRowsCollapsible={[4]}
    groups={[
      {content: t('calc__health__title'), firstRow: 0, noTitleBreak: true},
    ]}
    groupsColumn=''
    isPdf={props.isPdf}
    result={{
      padding: '0px',
      tooltip: t('calc__health__result__tt'),
      title: t('calc__health__result__title'),
      subtitle: t('calc__health__result__subtitle'),
      units: `${v.currency.sign}/${t('units__' + values.resultsUnitsAmount)}/${t('units__' + values.resultsUnitsPeriod)}`,
      value: f(v.longTermReturnsHealth.totalSavingsFinal.difference, 2).text,
    }}
  />
}